import { createFileRoute, redirect } from '@tanstack/react-router'
import { OrganizationDetailPage } from '@/pages/Organizations/OrganizationDetailPage'
import { useAuthStore } from '@/store/authStore'
import { canAccessRoute } from '@/lib/roles'

export const Route = createFileRoute('/_authenticated/organizations_/$orgId')({
  component: RouteComponent,
  beforeLoad: () => {
    const role = useAuthStore.getState().user?.role
    if (!canAccessRoute(role, '/organizations')) {
      throw redirect({ to: '/' })
    }
  },
})

function RouteComponent() {
  const { orgId } = Route.useParams()
  return <OrganizationDetailPage orgId={orgId} />
}
